import { Injectable } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { MatDateRangeSelectionStrategy, DateRange } from '@angular/material/datepicker';

@Injectable()
export class WeekRangeSelectionStrategy<D> implements MatDateRangeSelectionStrategy<D> {
  constructor(private _dateAdapter: DateAdapter<D>) {}

  selectionFinished(date: D | null): DateRange<D> {
    return this._createWeekRange(date);
  }

  createPreview(activeDate: D | null): DateRange<D> {
    return this._createWeekRange(activeDate);
  }

  private _createWeekRange(date: D | null): DateRange<D> {
    // @ts-ignore weekday does exist, but how to let typescript know?
    if (!date || date?.weekday !== 1) {
      const dateObjAsAny: any = date;
      const d = dateObjAsAny?.weekday;
      if (d) {
        const start = this._dateAdapter.addCalendarDays(date, -d + 1);
        const end = this._dateAdapter.addCalendarDays(start, 6);
        return new DateRange<D>(start, end);
      } else return new DateRange<D>(null, null);
    }
    const end = this._dateAdapter.addCalendarDays(date, 6);
    return new DateRange<D>(date, end);
  }
}
